<template>
    <div class="flex desktop:flex-row items-center" :class="ctaListClasses">
        <div 
            v-for="(cta, index) in ctaList" 
            :key="index"
            :class="[
                ctaList.length > 1 ? 'tablet:pr-5' : '',
                ctaWidth
            ]"
        >
            <div 
                class="items-center tablet:flex tablet:justify-center widescreen:justify-start"
                :class="paddingTop"
            >
                <!-- Check Availability Button -->
                <button
                    v-if="isCheckAvailabilityCta(cta)"
                    @click="toggleCheckAvailability"
                    class="track btn-primary"
                    :data-category="cta.gaCategory || ''"
                    :data-action="cta.gaAction || ''"
                    :data-label="cta.gaLabel || ''"
                >
                    {{ getCtaText(cta) }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SplitHeroCta',
    props: {
        ctaList: {
            type: Array,
            required: true,
            default: () => []
        },
        ctaListClasses: {
            type: String,
            default: ''
        },
        ctaWidth: {
            type: String,
            default: ''
        },
        paddingTop: {
            type: String,
            default: 'mt-7'
        }
    },
    methods: {
        isCheckAvailabilityCta(cta) {
            const url = this.getCtaUrl(cta)
            return url === '<check-availability>' || url.includes('<check-availability>')
        },
        
        getCtaUrl(cta) {
            return cta.url || ''
        },
        
        getCtaText(cta) {
            return cta.text || ''
        },
        
        toggleCheckAvailability() {
            if (this.$store && this.$store.getters.showOfferCards) {
                window.location.href = `${window.location.pathname}#offers`
            } else if (this.$store) {
                this.$store.dispatch('toggleCheckAvailabilityModal', {
                    visible: true,
                    currentCustomerCheck: false,
                    movingToAddress: false,
                })
            } else {
                console.error('toggleCheckAvailability() err')
            }
        }
    }
}
</script>